<template>
	<div>
		<br />
		<div class="col-sm-12 text-right">
			<h1>Aplicaciones BpB Admin</h1>
		</div>
		<br />

		<div class="d-flex flex-wrap">
      <div v-for="item in userMenu" :key="item.route_name" class="col-md-4">
        <div class="bpb-card">
          <div class="card-body">
            <div class="text-center">
              <img :src="item.img.src" :alt="item.img.alt" width="80px" />
            </div>
            <h4 class="card-title">{{ item.title }}</h4>
            <p class="card-subtitle text-muted" v-if="item.subtitle">{{ item.subtitle }}</p>
            <router-link :class="item.disabled && 'disabled'" :to="{name: item.route_name}" class="btn complementary-btn">Acceder</router-link>
          </div>
        </div>
      </div>
		</div>


	</div>
</template>

<script type="text/javascript">
	export default {
    data(){
      return {
        itemsMenu: [
          {
            disabled: false,
            app: 'garantias_app',
            route_name: 'garantias_app_fideicomisos_index',
            title: 'Fideicomisos',
            subtitle: 'Administración de fideicomisos',
            permisos_validacion: 'fideicomisos_listar',
            img: { src: 'https://static.bienparabien.com/constelacion/img/solicitudes.png', alt: 'Fideicomisos' }
          }
          ,{
            disabled: false,
            app: 'garantias_app',
            route_name: 'garantias_app_convenios_index',
            title: 'Convenios',
            subtitle: 'Administración de convenios',
            permisos_validacion: 'convenios_listar',
            img: { src: 'https://static.bienparabien.com/constelacion/img/aplicaciones.png', alt: 'Convenios' }
          }
          ,{
            disabled: false,
            app: 'garantias_app',
            route_name: 'garantias_app_patrimonios_index',
            title: 'Patrimonios',
            subtitle: 'Administración de patrimonios',
            permisos_validacion: 'patrimonios_listar',
            img: { src: 'https://static.bienparabien.com/constelacion/img/aplicaciones.png', alt: 'Patrimonios' }
          }
          ,{
            disabled: false,
            app: 'garantias_app',
            route_name: 'garantias_app_clientes_index',
            title: 'Clientes',
            subtitle: 'Administración de clientes',
            permisos_validacion: 'clientes_listar',
            img: { src: 'https://static.bienparabien.com/constelacion/img/partes.png', alt: 'Clientes' }
          }
          ,{
            disabled: false,
            app: 'garantias_app',
            route_name: 'garantias_app_garantias_index',
            title: 'Gestión de garantías',
            subtitle: 'Administración de garantías',
            permisos_validacion: 'garantias_listar',
            img: { src: 'https://static.bienparabien.com/constelacion/img/aplicaciones.png', alt: 'Gestión de garantías' }
          }
          ,{
            disabled: false,
            app: 'garantias_app',
            route_name: 'garantias_app_garantias_venta_index',
            title: 'Garantías para venta',
            subtitle: 'Administración de garantías para venta',
            permisos_validacion: 'garantias_venta_listar',
            img: { src: 'https://static.bienparabien.com/constelacion/img/aplicaciones.png', alt: 'Garantías para venta' }
          }
          ,{
            disabled: false,
            app: 'garantias_app',
            route_name: 'garantias_app_catalogos_index',
            title: 'Catálogos',
            subtitle: 'Administración de catálogos',
            permisos_validacion: 'catalogos_listar',
            img: { src: 'https://static.bienparabien.com/constelacion/img/list_01_b.png', alt: 'Catálogos' }
          }
          ,{
            disabled: false,
            app: 'garantias_app',
            route_name: 'garantias_app_fondeadores_index',
            title: 'Fondeadores',
            subtitle: 'Administración de fondeadores',
            permisos_validacion: 'fondeadores_listar',
            img: { src: 'https://static.bienparabien.com/constelacion/img/fondeadores.png', alt: 'Fondeadores' }
          }

          ,{
            disabled: false,
            app: 'garantias_app',
            route_name: 'garantias_app_campos_dinamicos_index',
            title: 'Campos dinámicos',
            subtitle: 'Administración de campos dinámicos',
            permisos_validacion: 'campos_dinamicos_listar',
            img: { src: 'https://static.bienparabien.com/constelacion/img/gear.svg', alt: 'Campos Dinámicos' }
          }

          ,{
            disabled: false,
            app: 'garantias_app',
            route_name: 'garantias_app_brokers_index',
            title: 'Brokers de venta',
            subtitle: 'Administración de brokers',
            permisos_validacion: 'brokers_listar',
            img: { src: 'https://static.bienparabien.com/constelacion/img/partes.png', alt: 'Brokers' }
          }

        ],
        userMenu: [],
      }
    },
		mounted: function() {
			let menu = {title: 'Garantias App'};
			this.$store.commit('setMenu',[menu]);
      this.loadMenu(menu);
		},
    methods: {
      loadMenu(menu){
        for (const item of this.itemsMenu) {
         if (this.$auth.can(item.app, item.permisos_validacion) && !item.disabled) {
           this.userMenu.push(item);
           menu[item.route_name] = item.title;
         }
        }
      }
    }
	}
</script>
